import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Company, PagedResult } from 'app/core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuerifyService, QueryOptions } from './../services/querify.service';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class CompanyApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
    private querify: QuerifyService,
  ) {}

  search(query?: Record<string, any>, options?: Record<string, any>): Observable<PagedResult> {
    const variables: Record<string, any> = this.querify.transformOptions(query, options);
    variables.orderByDistance = (options && options.orderByDistance) || null;

    return this.apollo
      .query({
        query: this.queries.companiesPaginated(),
        variables,
      })
      .pipe(
        map(({ data }) => {
          return data['companies'];
        })
      );
  }

  async searchOne(id: string): Promise<Company> {
    return this.apollo
      .query({
        query: this.queries.searchCompany(),
        variables: { id }
      })
      .toPromise()
      .then(({ data }) => {
        return data['company'];
      });
  }

  async getCompanyByConfig({ locationId, segmentId, maintenanceTypeId }: { locationId: string, maintenanceTypeId: string, segmentId: string }): Promise<Company> {
    return this.apollo
      .query({
        query: this.queries.companyByConfig(),
        variables: { locationId, maintenanceTypeId, segmentId }
      })
      .toPromise()
      .then(({ data }) => data['companyByConfig']);
  }


}
